export type ParkingTypesProps = {
  hasAttachedGarage: boolean;
  hasCoveredParking: boolean;
  hasDetachedGarage: boolean;
  hasMultiLevelGarage: boolean;
  hasNoneParking: boolean;
  hasParkingLot: boolean;
  hasUndergroundGarage: boolean;
};

const ParkingTypes = ({
  hasAttachedGarage = false,
  hasCoveredParking = false,
  hasDetachedGarage = false,
  hasMultiLevelGarage = false,
  hasNoneParking = false,
  hasParkingLot = false,
  hasUndergroundGarage = false,
}: Partial<ParkingTypesProps> = {}): ParkingTypesProps => ({
  hasAttachedGarage: Boolean(hasAttachedGarage),
  hasCoveredParking: Boolean(hasCoveredParking),
  hasDetachedGarage: Boolean(hasDetachedGarage),
  hasMultiLevelGarage: Boolean(hasMultiLevelGarage),
  hasNoneParking: Boolean(hasNoneParking),
  hasParkingLot: Boolean(hasParkingLot),
  hasUndergroundGarage: Boolean(hasUndergroundGarage),
});

export default ParkingTypes;
